import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"
import { SearchInput } from "components"

const GlobalNavSearchFieldCompact = ({
  height,
  placeholderText,
  innerInputRef,
  ...searchFieldProps
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      backgroundColor: COLOR_PALETTE.BLACK,
      height
    }}>
    <div
      style={{
        height: "calc(100% - 2em)",
        borderLeft: `1px solid ${COLOR_PALETTE.GRAY_DARKER}`
      }} />
    <div
      style={{
        padding: "0.5em 1em",
        width: "100%"
      }}>
      <SearchInput
        innerRef={innerInputRef}
        lineColor={COLOR_PALETTE.GRAY_DARKER}
        focusStyle={false}
        styleName={"dark"}
        placeholder={placeholderText}
        {...searchFieldProps} />
    </div>
  </div>
)

GlobalNavSearchFieldCompact.propTypes = {}

export default Radium(GlobalNavSearchFieldCompact)

const styles = {}



// WEBPACK FOOTER //
// ./src/containers/global-nav-search/search-field-compact.jsx